import React from "react";
import { Box, Stack, Typography } from "@mui/material";

/**
 * Jersey number under any of the key spellings the API has returned it as.
 * Returns null when absent so the caller's meta line drops the field.
 */
export const jerseyNumberOf = (p = {}) => {
  const v = p.jersey_no ?? p.jersey_number ?? p.jr_no ?? p.jersey;
  return v === null || v === undefined || v === "" ? null : v;
};

/**
 * Labelled metadata for a player row ("Organizer: Riverside FC").
 * Bare values are ambiguous once a row mixes team, organizer and match score,
 * so every field carries its name. Empty/nullish entries are dropped.
 *
 * @param {Array<{label: string, value: any}>} items
 * @param {number} [size]  font size in px (default 11)
 */
export default function PlayerMetaLine({ items = [], size = 11 }) {
  const shown = items.filter(
    (i) => i && i.value !== null && i.value !== undefined && i.value !== ""
  );
  if (!shown.length) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      sx={{ columnGap: 1.25, rowGap: 0.25, minWidth: 0 }}
    >
      {shown.map((i) => (
        <Typography
          key={i.label}
          sx={{
            fontSize: `${size}px`,
            color: "var(--text-2)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <Box component="span" sx={{ fontWeight: 600 }}>
            {i.label}:
          </Box>{" "}
          {i.value}
        </Typography>
      ))}
    </Stack>
  );
}
